<template>
  <div>
    <RefreshResults
      v-if="showRefreshNotification"
      :type="'car'"
      @clearResults="clearResults"
      @refreshSearch="refreshSearch"
    />
    <div v-else>
      <div :style="meetingCarResult ? 'margin: auto;' : ''">
        <div :class="(meetingCarResult ? '' : ' ') + ''">
          <div v-if="items.length > 0">
            <div v-if="sortedfilteredItems">
              <div class="mt-1 mb-2" :class="pathMixin_isMeeting ? 'box' : ''">
                <CarFiltersDropdowns
                  v-model="filters"
                  :formData="formData"
                  :sortOptions="sortOptions"
                  :availableChains="availableProviders"
                  :preferredChains="preferredVendors"
                  :filteredChains="filteredProviders"
                  :availableCategories="availableCategories"
                  :filteredCategories="filteredCategories"
                  :availableTypes="availableTypes"
                  :filteredTypes="filteredTypes"
                  :vendorsCars="$globals.vendors.carProviders"
                  :mapView="mapView"
                  :priceRange="priceRange"
                  :sliderData="sliderData"
                  :availablePolicies="availablePolicies"
                  :highestRating="highestRating"
                  :highlights="highlightedFilters"
                  :originalPriceRange="originalPriceRange"
                  @clearFilters="defaultFilters()"
                  @resetFilter="resetFilter"
                />
              </div>

              <div
                v-if="!(sortedfilteredItems.length > 0) && !loading"
                style="text-align: center"
              >
                <b-message aria-close-label="Close message">
                  No results found for this search.<br />
                  Try removing some filters to see more results.<br />
                  <b-button @click="defaultFilters()" type="is-primary"
                    >Restore defaults</b-button
                  >
                </b-message>
              </div>

              <div v-else>
                <div
                  data-test="car_results_list"
                  class="pl-4 pr-4 pt-4"
                  :class="
                    windowWidth >= bookingFixedWidth ? 'bookingFixed' : ''
                  "
                >
                  <HiddenResultsNotification
                    v-if="hiddenItemsCount > 0"
                    :hiddenItemsCount="hiddenItemsCount"
                  ></HiddenResultsNotification>
                  <div v-if="mapView" style="margins: auto;">
                    <GMapView
                      :lat="
                        parseFloat(
                          this.formData.pickupLocation.geocode.latitude
                        )
                      "
                      :long="
                        parseFloat(
                          this.formData.pickupLocation.geocode.longitude
                        )
                      "
                      :cars="true"
                      :locations="this.locationInfo"
                      :addingData="addingData"
                      @selected="selectedByMap"
                    />
                  </div>

                  <!--
                  
                  <div
                    v-else
                    v-for="result in filteredItems.slice(0)"
                    :key="result.id"
                    data-test="c_result"
                    :data-id="result.id"
                  >
                    <CResult
                      :solution="result"
                      :preferredVendors="preferredVendors"
                      :searchDetails="searchDetails"
                      :searchBody="searchBody"
                      :session="session"
                      :puLocation="locationInfo[result.pickupInfo.locationKey]"
                      :doLocation="locationInfo[result.dropoffInfo.locationKey]"
                      @pickupSelected="
                        pickupSelected(result.pickupInfo.locationKey)
                      "
                      @dropoffSelected="
                        dropoffSelected(result.dropoffInfo.locationKey)
                      "
                    />
                  </div>
                  -->

                  <DynamicScroller
                    page-mode
                    :items="sortedfilteredItems.slice(0)"
                    :min-item-size="302"
                    :buffer="800"
                    class="scroller"
                    key-field="id"
                  >
                    <template v-slot="{ item, index, active }">
                      <DynamicScrollerItem
                        :item="item"
                        :active="active"
                        :data-index="index"
                        data-test="car_item"
                        :data-id="item.id"
                      >
                        <CResult
                          :solution="item"
                          :searchDetails="searchDetails"
                          :searchBody="searchBody"
                          :session="session"
                          :preferredVendors="preferredVendors"
                          :puLocation="
                            locationInfo[item.pickupInfo.locationKey]
                          "
                          :doLocation="
                            locationInfo[item.dropoffInfo.locationKey]
                          "
                          @pickupSelected="
                            pickupSelected(item.pickupInfo.locationKey)
                          "
                          @dropoffSelected="
                            dropoffSelected(item.dropoffInfo.locationKey)
                          "
                        />
                      </DynamicScrollerItem>
                    </template>
                  </DynamicScroller>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="loading">
            <div v-for="(result, index) in skelItems" :key="index">
              <ResultSkele />
            </div>
          </div>
        </div>
      </div>

      <SearchErrorMessage
        v-if="showErrors"
        :errors="errors"
        :userPayload="null"
        :code="null"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
let intersection = require("lodash.intersection");

import CResult from "./CResult";
import ResultSkele from "../../SkeletonLoaders/ResultSkele.vue";
import GMapView from "../../GMap/GMapView.vue";
import HiddenResultsNotification from "../HiddenResultsNotification.vue";
import CarFiltersDropdowns from "../../Filters/CarFiltersDropdowns";
import RefreshResults from "../RefreshResults";
import bookingMixin from "../../../mixins/bookingMixin";
import SearchErrorMessage from "@/components/BookTravel/SearchErrorMessage.vue";
import { mapState } from "vuex";
import {
  RecycleScroller,
  DynamicScroller,
  DynamicScrollerItem,
} from "vue-virtual-scroller";

export default {
  name: "CarResults",
  mixins: [bookingMixin],
  components: {
    CResult,
    ResultSkele,
    GMapView,
    HiddenResultsNotification,
    CarFiltersDropdowns,
    RefreshResults,
    SearchErrorMessage,
    DynamicScroller,
    DynamicScrollerItem,
  },
  props: {
    highestRating: [],
    formData: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      items: [],
      loading: false,
      error: false,
      errors: [],
      windowWidth: window.innerWidth,
      refreshDialogComp: null,
      searchDetails: null,
      filters: {
        sortOrder:"Price Asc",
        selectedProviders: [],
        selectedCategories: [],
        selectedTypes: [],
        maxPrice: [0, 1500],
        minPolicy: "",
      },
      session: null,
      no_results: false,
      display_search: false,
      first_selected: false,
      locationInfo: {},
      policyOnly: false,
      selectedPickup: false,
      selectedDropoff: false,
      expandedItems: [],
      mobileFiltersModal: false,
      avalLogos: [],

      searchBody: {},
      skelItems: [{}, {}, {}, {}],
      refreshTimer: null,
      showRefreshNotification: false,
      highlightedFilters: {
        sorting: false,
        policy: false,
        price: false,
        chain: false,
        type: false,
        size: false,
      },
      //originalPriceRange: [],
      addingData: false,
    };
  },
  computed: {
    ...mapState(["bookTravel"]),
    meetingCarResult() {
      return this.$route.name == "MeetingsCarResults";
    },
    sortOptions(){
          let options = [
            {value: 'Price Asc', label: 'Price (Low to High)'},
            {value: 'Price Desc', label: 'Price (High to Low)'},
          ];

          if (this.preferredVendors.length > 0){
            options.push({value: 'Preferred Vendors', label: 'Preferred Vendors'});
          }
          return options;
    },
    sliderData() {
      var data = this.filterItems("price").map(
        (x) => x.pricingInfo.averagePricePerDay
      );
      data = data.filter((i) => {
        return i < 1500;
      });
      data.sort((a, b) => a - b);
      return data;
    },
    hiddenItemsCount() {
      let items = this.items;

      items = items.filter((i) => {
        return !i.isVisible;
      });

      return items.length;
    },
    priceRange() {
      return this.getPriceRange(this.filterItems("price"));
    },
    originalPriceRange() {
      return this.getPriceRange(this.items);
    },
    availablePolicies() {
      return this.getPolicies(this.filteredItems);
    },
    availableProviders() {
      let items = this.items;
      return this.getProviders(items);
    },
    filteredProviders() {
      let items = this.filterItems("provider");
      if (items) {
        return this.getProviders(items);
      } else {
        return [];
      }
    },
    availableCategories() {
      let items = this.items;
      return this.getCategories(items);
    },
    filteredCategories() {
      let items = this.filterItems("category");
      return this.getCategories(items);
    },
    availableTypes() {
      let items = this.items;
      return this.getTypes(items);
    },
    filteredTypes() {
      let items = this.filterItems("type");
      return this.getTypes(items);
    },
    filteredItems() {
      return this.filterItems();
    },
    sortedfilteredItems() {
      return this.sort();
    },
    sortOrder() {
      return this.filters.sortOrder;
    },
    sameDropoff() {
      return !this.formData.advancedSettings.diffDropLoc;
    },
    updatedPolicyFilter() {
      return this.filters.minPolicy;
    },
    updatedMaxPrice0() {
      return this.filters.maxPrice[0];
    },
    updatedMaxPrice1() {
      return this.filters.maxPrice[1];
    },
    updatedSelectedTypes() {
      return this.filters.selectedTypes;
    },
    updatedSelectedSize() {
      return this.filters.selectedCategories;
    },
    updatedSelectedChain() {
      return this.filters.selectedProviders;
    },
    mapView() {
      return this.bookTravel.showMapView.car;
    },
    showErrors() {
      return (
        this.loading == false &&
        (this.errors.length > 0 || this.items.length == 0)
      );
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    preferredVendors() {
      return this.profile.preferredCarVendors || [];
    },
  },
  methods: {
    filterItems(category = null) {
      var items = this.items;

      if (Object.keys(items).length > 0) {
        // Filter out hidden
        items = items.filter((i) => {
          return i.isVisible;
        });
        if (this.selectedPickup) {
          items = items.filter((i) => {
            return i.pickupInfo.locationKey == this.selectedPickup;
          });
        }
        if (this.selectedDropoff) {
          items = items.filter((i) => {
            return i.dropoffInfo.locationKey == this.selectedDropoff;
          });
        }
        if (
          this.filters.maxPrice &&
          category != "price" &&
          !(
            this.filters.maxPrice[0] == this.priceRange[0] &&
            this.filters.maxPrice[1] == this.priceRange[1]
          )
        ) {
          items = items.filter((i) => {
            return i.pricingInfo.averagePricePerDay <= this.filters.maxPrice[1];
          });
          items = items.filter((i) => {
            return i.pricingInfo.averagePricePerDay >= this.filters.maxPrice[0];
          });
        }
        if (this.filters.minRating) {
          items = items.filter((i) => {
            return i.overallScore >= this.filters.minRating;
          });
        }
        if (
          this.filters.selectedProviders.length > 0 &&
          category != "provider"
        ) {
          items = items.filter((i) => {
            return this.filters.selectedProviders.includes(i.companyInfo.code);
          });
        }
        if (
          this.filters.selectedCategories.length > 0 &&
          category != "category"
        ) {
          items = items.filter((i) => {
            return this.filters.selectedCategories.includes(
              i.vehicleInfo.categoryName
            );
          });
        }
        if (this.filters.selectedTypes.length > 0 && category != "type") {
          items = items.filter((i) => {
            return this.filters.selectedTypes.includes(
              i.vehicleInfo.bodyTypeGroup
            );
          });
        }
        if (this.filters.minPolicy) {
          if (this.filters.minPolicy == 1) {
            items = items.filter((i) => {
              return i.travelPolicy.summary.rulesTriggeredCount == 0;
            });
          } else if (this.filters.minPolicy == 2) {
            items = items.filter((i) => {
              return i.travelPolicy.summary.hardApprovalRequiredCount == 0;
            });
          }
        }
      }

      return items;
    },
    selectedByMap(code) {
      this.toggleMapView("car");
      this.selectedPickup = code;
    },
    defaultFilters(showRestoreMessage = true) {
      if (showRestoreMessage) {
        this.$buefy.toast.open({
          message: "Please wait while we're restoring defaults",
          type: "is-info",
        });
      }
      this.filters.sortOrder = "Price Asc";
      this.filters.minPolicy = "";
      this.filters.selectedProviders = [];
      this.filters.selectedCategories = [];
      this.filters.selectedTypes = [];
      this.filters.maxPrice = [0, 1500];
    },
    resetFilter(value) {
      // console.log('resetFilter CAR: filterType', value);
      switch (value) {
        case "sortOrder":
        case "minPolicy":
          this.filters[value] = "";
          break;
        case "maxPrice":
          this.filters.maxPrice[0] = this.originalPriceRange[0];
          this.filters.maxPrice[1] = this.originalPriceRange[1];
          this.highlightedFilters.price = false;
          break;
        case "selectedProviders":
        case "selectedCategories":
        case "selectedTypes":
          this.filters[value] = [];
          break;
        default:
          this.defaultFilters();
          this.highlightedFilters.price = false;
      }
    },
    pickupSelected(val) {
      this.selectedPickup = val;
    },
    dropoffSelected(val) {
      this.selectedDropoff = val;
    },
    timeConvert(time) {
      if (parseInt(time) < 10) {
        return "0" + time + ":00";
      } else {
        return time + ":00";
      }
    },

    async getData(refresh = false) {
      console.log("called getData");
      this.loading = true;
      this.error = false;
      this.items = [];

      let query = this.formData;

      let startDate = moment(query.pickupDate).format("YYYY-MM-DD");
      let endDate = moment(query.dropoffDate).format("YYYY-MM-DD");

      let pickupTime;
      let dropoffTime;

      if (typeof query.pickupTime == "number") {
        pickupTime = this.timeConvert(query.pickupTime);
      } else {
        pickupTime = query.pickupTime;
      }

      if (typeof query.dropoffTime == "number") {
        dropoffTime = this.timeConvert(query.dropoffTime);
      } else {
        dropoffTime = query.dropoffTime;
      }

      let body = {
        meta: {
          stateful: true,
          sessionKey: null,
          normalizeResponse: true,
          travelPolicyId: null,
        },
        pickupDate: {
          date: startDate,
          time: pickupTime,
        },
        dropoffDate: {
          date: endDate,
          time: dropoffTime,
        },
      };

      if (
        this.$store.state.travellersAndTrips.travellers.tripType == "business"
      ) {
        body.meta.travelPolicyId = this.$globals.travellerProfile.travelPolicyId;
        body.meta.travelerContactId = this.$globals.travellerProfile.id;
      }

      if (query.pickupLocation) {
        if (query.advancedSettings.airportSearch === true) {
          body.pickupLocation = {
            coordinates: {
              latitude: query.pickupLocation.geocode.latitude,
              longitude: query.pickupLocation.geocode.longitude,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        } else {
          body.pickupLocation = {
            coordinates: {
              latitude: query.pickupLocation.lat,
              longitude: query.pickupLocation.lng,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        }
      }

      if (query.dropoffLocation) {
        if (query.advancedSettings.airportSearch === true) {
          body.dropoffLocation = {
            coordinates: {
              latitude: query.dropoffLocation.geocode.latitude,
              longitude: query.dropoffLocation.geocode.longitude,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        } else {
          body.dropoffLocation = {
            coordinates: {
              latitude: query.dropoffLocation.lat,
              longitude: query.dropoffLocation.lng,
            },
            radius: {
              distance: 5,
              distanceUnit: "miles",
            },
          };
        }
      }

      if (query.pickupLocation.code) {
        body.pickupLocation = {
          airportCode: query.pickupLocation.code,
        };
      }
      if (query.dropoffLocation.code) {
        body.dropoffLocation = {
          airportCode: query.dropoffLocation.code,
        };
      }

      if (query.advancedSettings.active) {
        if (query.advancedSettings.chain != []) {
          body.companyCodes = [];
          for (const [key, value] of query.advancedSettings.chain) {
            var company = {
              companyCode: key,
            };
            body.companyCodes.push(company);
          }
        }
      }

      // console.log('body of car: ', body);

      this.$app
        .huddleLabsServerCall("amadeus/car/search", body)
        .then((result) => {
          this.loading = false;

          if (result.data && result.data.length > 0) {
            this.items = result.data;
            // this.session = result.meta.sessionKey
            // this.searchBody.meta.sessionKey = result.meta.sessionKey
            this.locationInfo = result.meta.locations;
            this.finalizeItemsLoading("car");
          } else if (result.errors) {
            //no results, show json error message returned from server
            this.errors = result.errors;
            this.error_id = result.meta?.error_log_id;
          } else if (result.message) {
            //general server error (no json)
            this.errors = [{ title: result.message }];
          } else {
            //else show default error message
            this.errors = [{ title: "Search failed or no results found." }];
          }
        });
    },
    selectAll() {
      this.filters.selectedProviders = this.availableProviders;
    },
    clearAll() {
      this.filters.selectedProviders = [];
    },
    getPolicies(items) {
      let policies = {};
      if (items) {
        if (items.length) {
          for (let i = 0; i < items.length; i++) {
            if (
              items[i].travelPolicy &&
              items[i].travelPolicy.summary.rulesTriggeredCount == 0
            ) {
              policies.none = true;
              policies.soft = true;
              break;
            } else if (
              items[i].travelPolicy &&
              items[i].travelPolicy.summary.hardApprovalRequiredCount == 0
            ) {
              policies.soft = true;
            }
          }
        }
      }
      return policies;
    },
    getProviders(items) {
      let vendors = this.$globals.vendors;
      let carriersList = ["Preferred Vendors Only"];
      if (items) {
        for (let i = 0; i < items.length; i++) {
          var carrier;
          carrier = items[i].companyInfo.code;
          if (!carriersList.includes(carrier) && carrier != "") {
            carriersList.push(carrier);
          }
        }
      }
      // return carriersList
      return carriersList.sort(function(a, b) {
        if (vendors.carProviders[a] < vendors.carProviders[b]) {
          return -1;
        } else {
          return 1;
        }
        // return vendors.carProviders[a] - vendors.carProviders[b]
      });
    },
    getCategories(items) {
      let carriersList = [];
      if (items) {
        for (let i = 0; i < items.length; i++) {
          var carrier;
          carrier = items[i].vehicleInfo.categoryName;
          if (!carriersList.includes(carrier) && carrier != "") {
            carriersList.push(carrier);
          }
        }
      }
      return carriersList.sort();
    },
    getTypes(items) {
      let carriersList = [];
      if (items) {
        for (let i = 0; i < items.length; i++) {
          var carrier;
          carrier = items[i].vehicleInfo.bodyTypeGroup;
          if (!carriersList.includes(carrier) && carrier != "") {
            carriersList.push(carrier);
          }
        }
      }
      return carriersList.sort();
    },
    getPriceRange(items) {
      let range = [];

      if (items) {
        if (items.length) {
          range = [
            items[0].pricingInfo.averagePricePerDay,
            items[0].pricingInfo.averagePricePerDay,
          ];
          for (let i = 1; i < items.length; i++) {
            var price = items[i].pricingInfo.averagePricePerDay;
            if (price < range[0]) {
              range[0] = price;
            } else if (price > range[1]) {
              range[1] = price;
            }
          }
          // range[0] = Math.round(range[0] / 100)
          // range[1] = Math.round(range[1] / 100)
        }
      }
      return range;
    },
    sort() {
      let items = this.filteredItems;

      if (this.filters.sortOrder == "Price Asc") {
        items.sort((a, b) => {
          return (
            a.pricingInfo.averagePricePerDay - b.pricingInfo.averagePricePerDay
          );
        });
      } else if (this.filters.sortOrder == "Price Desc") {
        items.sort((a, b) => {
          return (
            b.pricingInfo.averagePricePerDay - a.pricingInfo.averagePricePerDay
          );
        });
      } else if (this.filters.sortOrder == "Preferred Vendors") {
        items.sort((a, b) => {
          return this.preferredVendors.includes(a.companyInfo.code)
            ? -1
            : this.preferredVendors.includes(b.companyInfo.code)
            ? 1
            : 0;
        });
      }
      // else{
      //   this.items.sort((a, b) => {
      //     return parseFloat(a.pricingInfo.averagePricePerDay) - parseFloat(b.pricingInfo.averagePricePerDay);
      //   });
      // }
      return items;
    },
  },
  watch: {
    //uses a deep watcher to trigger call to this.getData() upon receiving a CarForm submit/update
    formData: {
      handler(newVal, prevVal) {
        console.log("called formData watcher");
        this.showRefreshNotification = false;
        this.getData();
      },
      deep: false,
    },

    // TODO test
    showRefreshNotification(newVal, prevVal) {
      this.setSearchRecordsStatus("car", newVal);
    },
    /*
    sortOrder: function(newVal, prevVal) {
      // console.log('watching sortOrder()', this.filters);
      // console.log('prevVal:', JSON.stringify(prevVal));
      // console.log('newVal:', JSON.stringify(newVal));
      if (this.sortOrder === "" || this.sortOrder === null) {
        this.highlightedFilters.sorting = false;
      } else {
        this.highlightedFilters.sorting = true;
      }

      this.sort();
    },
    */
    updatedPolicyFilter(newVal, prevVal) {
      newVal !== ""
        ? (this.highlightedFilters.policy = true)
        : (this.highlightedFilters.policy = false);
    },
    updatedMaxPrice0(newVal, prevVal) {
      newVal !== this.originalPriceRange[0] ||
      this.originalPriceRange[1] !== this.filters.maxPrice[1]
        ? (this.highlightedFilters.price = true)
        : (this.highlightedFilters.price = false);
    },
    updatedMaxPrice1(newVal, prevVal) {
      newVal !== this.originalPriceRange[1] ||
      this.originalPriceRange[0] !== this.filters.maxPrice[0]
        ? (this.highlightedFilters.price = true)
        : (this.highlightedFilters.price = false);
    },
    updatedSelectedTypes(newVal, prevVal) {
      newVal.length > 0
        ? (this.highlightedFilters.type = true)
        : (this.highlightedFilters.type = false);
    },
    updatedSelectedSize(newVal, prevVal) {
      newVal.length > 0
        ? (this.highlightedFilters.size = true)
        : (this.highlightedFilters.size = false);
    },
    updatedSelectedChain(newVal, prevVal) {
      newVal.length > 0
        ? (this.highlightedFilters.chain = true)
        : (this.highlightedFilters.chain = false);
    },
  },
  mounted() {
    this.setSearchRecordsStatus("car", this.showRefreshNotification);
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    this.getData();
    
    //show preferred vendor results first
    if (this.preferredVendors.length > 0) {
      this.filters.sortOrder = "Preferred Vendors";
    }
  },
  beforeDestroy() {
    if (this.refreshDialogComp) {
      this.refreshDialogComp.close();
    }
    clearTimeout(this.refreshTimer);
  },
};
</script>

<style lang="scss" scoped>
.field {
  border-radius: 5px;
  width: 800px;
}
.infoi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.infok {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.infoj {
  position: fixed;
  bottom: 0%;
  left: 256px;
  z-index: 3;
  // transform: translate(0%, -50%);
}
</style>
